import { render, staticRenderFns } from "./AssetAddForm.vue?vue&type=template&id=b5101af4&scoped=true"
import script from "./AssetAddForm.vue?vue&type=script&lang=js"
export * from "./AssetAddForm.vue?vue&type=script&lang=js"
import style0 from "./AssetAddForm.vue?vue&type=style&index=0&id=b5101af4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5101af4",
  null
  
)

export default component.exports